import React from "react";

import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";
import { toPercentage, toRounded } from "@/utils";

interface SearchBoxProps {
  name: string;
  value: number;
  growth?: number;
  valueFormatter?: (value: number) => number | string;
  icon?: React.ReactNode;
  size?: "small" | "medium";
  loading?: boolean;
}

const MiniStatBox: React.FC<SearchBoxProps> = ({
  name,
  value,
  growth,
  valueFormatter = toRounded,
  icon,
  size = "medium",
  loading = false
}) => {
  const theme = useTheme();

  return (
    <HelpBox title={name}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        spacing={2}
        border={1}
        borderRadius={1}
        borderColor={theme.palette.divider}
        p={size === "small" ? 0.5 : 1}
        minWidth={size === "small" ? "100px" : "120px"}
        height={size === "small" ? "40px" : "50px"}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {icon}
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            minWidth: 0
          }}
        >
          {loading ? (
            <CircularProgress size={24} sx={{ mx: 2 }}/>
          ) : (
            <>
              <Typography variant={size === "small" ? "body1" : "h6"}>
                {valueFormatter(value)}
              </Typography>
              {growth &&
                <Stack direction="row" spacing={0}>
                  {growth > 0 ? (
                    <ArrowUpward fontSize="small" color={growth > 0 ? "success" : "error"}/>
                  ) : (
                    <ArrowDownward fontSize="small" color={growth > 0 ? "success" : "error"}/>
                  )}
                  <Typography variant="body2" color={growth > 0 ? "success" : "error"}>
                    {toPercentage(Math.abs(growth), 0)}
                  </Typography>
                </Stack>
              }
            </>
          )}

        </Box>
      </Stack>
    </HelpBox>
  );
};

export default MiniStatBox;
